import script from "./InventoryByPerson.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryByPerson.vue?vue&type=script&setup=true&lang=js"

import "./InventoryByPerson.vue?vue&type=style&index=0&id=40dedc1c&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40dedc1c"]])

export default __exports__